var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{attrs:{"for":_vm.id}},[_c('input',{attrs:{"id":_vm.id,"name":_vm.name,"aria-checked":_vm.currentlyChecked || _vm.preChecked,"role":"switch","type":"radio","tabindex":"0"},domProps:{"value":_vm.value,"checked":_vm.preChecked},on:{"change":function($event){return _vm.$emit('change', _vm.value)}}}),_vm._v("\n  "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }